module.exports = __webpack_public_path__ + "static/media/42x38-0.a984d02e.png";